import { convertUtcToUae, formatDateToDDMMYYYY } from "@utils/date-time";

/** DBCO-0048 - an ISO instant as the port reads it (Fujairah, UTC+4); a missing or unreadable value is a dash. */
export const formatInstant = (iso: string | null | undefined): string => {
  if (!iso) {
    return "-";
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return "-";
  }
  return date.toLocaleString("en-GB", {
    timeZone: "Asia/Dubai",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

/** DBCO-0105 - a grid date in UAE time, dd/MM/yyyy HH:mm; a missing or unreadable value is `empty`. */
export const formatGridInstant = (iso: string | null | undefined, empty = "-"): string =>
  iso && !Number.isNaN(new Date(iso).getTime())
    ? formatDateToDDMMYYYY(convertUtcToUae(iso), true)
    : empty;
